<form [formGroup]="generalForm">

  <div *ngIf="account_type == 'broker'">
    <div class="row">
      <div class="col-8">
        <div class="form-section">
          <div class="mb-3">
            <label for="broker_reference" class="form-label">{{
              "inputs.reference" | translate
              }}</label>
            <div class="input-group div-copy">
              <input type="text" class="form-control" id="broker_reference" #inputBrokerReference
                formControlName="broker_reference" placeholder="{{
                  'inputs.reference' | translate
                }}" required />
              <div class="input-group-append">
                <button class="btn btn-outline-secondary copy" type="button"
                  (click)="copyToClipboard(inputBrokerReference.value,$event)">
                  <i class="icon-copy"></i>
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="form-section">
          <div class="mb-3">
            <label for="broker_agent_id" class="form-label">{{
              "inputs.broker_agent" | translate
              }}</label>
            <ng-select formControlName="broker_agent_id" [items]="agentData" bindValue="reference"
              [placeholder]="'inputs.select_option' | translate" [searchable]="true" [clearable]="false">
              <ng-template ng-label-tmp let-item="item">{{ item.name }} {{ item.lastname }}</ng-template>
              <ng-template ng-option-tmp let-item="item">{{ item.name }} {{ item.lastname }}</ng-template>
            </ng-select>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="row" *ngIf="newCampaign ">
    <div class="row linea"></div>
    <div class="row">
      <div class="col-5">
        <div class="mb-3">
          <div class="column-list">
            <span
              *ngIf="campaign?.units"
              class="badge text-badge-list badge-units"
              [ngClass]="'units' | badgeVehicle"
              >{{ campaign?.virtual_available_units }}
              {{ "inputs.availables" | translate
              }}<span class="info-icon" tabindex="0">
                <i class="icon-notification"></i>
                <span class="tooltip">{{
                  "inputs.i.virtual_available_units" | translate
                }}</span>
              </span>
            </span>

            <span
              *ngIf="campaign?.units"
              class="badge text-badge-list badge-units2"
              [ngClass]="'units' | badgeVehicle"
              >{{ campaign?.units }}
              {{ "inputs.total_units" | translate }}</span
            >

            <span *ngIf="campaign?.vehicle_brand"> {{ campaign?.vehicle_brand }} {{
              campaign?.vehicle_model }} {{ campaign?.vehicle }}
              ({{campaign?.vehicle_model_year}}) </span>
            <span *ngIf="campaign?.vehicle_status" class="badge text-badge-list"
              [ngClass]="campaign.vehicle_status | badgeVehicle">{{ "badge-status_select-stage."
              + campaign?.vehicle_status | translate }}</span>
            <span *ngIf="campaign?.colour" class="secondary-text">
              <i class="icon-brush2"></i> {{ campaign?.colour }}</span>
          </div>
          <div class="column-list">
            <span>
              <i [ngClass]="campaign?.include_insurance ? 'icon-check text-success' : 'icon-cross2 text-danger'"></i>
              {{ "helper.include_insurance" | translate }}
              <span *ngIf="campaign?.include_insurance && campaign?.insurance_deductible" class="text-muted">({{ "helper.deductible" | translate }}: {{ campaign.insurance_deductible }}€)</span>
              <i *ngIf="campaign?.insurance_notes" class="icon-notification include-note-icon" [matTooltip]="campaign.insurance_notes" matTooltipPosition="above"></i>
            </span>
            <span>
              <i [ngClass]="campaign?.include_maintenance ? 'icon-check text-success' : 'icon-cross2 text-danger'"></i>
              {{ "helper.include_maintenance" | translate }}
              <i *ngIf="campaign?.maintenance_notes" class="icon-notification include-note-icon" [matTooltip]="campaign.maintenance_notes" matTooltipPosition="above"></i>
            </span>
            <span>
              <i [ngClass]="campaign?.include_tires ? 'icon-check text-success' : 'icon-cross2 text-danger'"></i>
              {{ "helper.include_tires" | translate }}
              <i *ngIf="campaign?.tires_notes" class="icon-notification include-note-icon" [matTooltip]="campaign.tires_notes" matTooltipPosition="above"></i>
            </span>
            <span>
              <i [ngClass]="campaign?.include_replacement_vehicle ? 'icon-check text-success' : 'icon-cross2 text-danger'"></i>
              {{ "helper.include_replacement_vehicle" | translate }}
              <i *ngIf="campaign?.replacement_vehicle_notes" class="icon-notification include-note-icon" [matTooltip]="campaign.replacement_vehicle_notes" matTooltipPosition="above"></i>
            </span>
          </div>

        </div>
      </div>
      <div class="col-3">
        <div class="mb-3">
          <div class="column-list">
            <span *ngIf="campaign?.supplier_name"> {{ campaign?.supplier_name }}</span><br>
            <span *ngIf="campaign?.vendor_name"> {{ campaign?.vendor_name }} </span><br>
            <span *ngIf="campaign?.campaign_vendor_reference"> {{ campaign?.campaign_vendor_reference }} </span><br
              *ngIf="campaign?.campaign_vendor_reference">
            <span *ngIf="campaign?.start_date"> <i class="icon-play-circle"></i>
              {{'forms.labels.start' | translate}} {{
              campaign?.start_date }} </span>
            <span *ngIf="campaign?.end_date"> <i class="icon-stop-circle"></i>
              {{'forms.labels.end' | translate}} {{
              campaign?.end_date }} </span>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="mb-3">
          <div class="column-list">
            <span class='comment text-secondary' *ngIf="campaign?.comments"> {{ campaign?.comments }}</span><br>
            <span class='comment text-secondary' *ngIf="campaign?.delivery_comments"> {{ campaign?.delivery_comments
              }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row linea"></div>
    <div class="col-12">
      <div class=" d-flex align-items-center justify-content-end">
        <input #customConfigCheckbox class="form-check-input" type="checkbox" id="custom_config"
          (change)="onCheckboxChange2($event)">
        <label class="form-check-label" for="custom_config">
          {{ "forms.buttons.custom_config" | translate }}
        </label>
      </div>
      <div class="row" [hidden]="!customConfig">
        <div class="col-6">
          <div class="mb-3">
            <label for="duration" class="form-label">{{
              "inputs.duration" | translate
              }}</label>
            <div class="input-group">
              <select id="duration" class="form-control" formControlName="duration">
                <option value="" disabled selected>
                  {{ "inputs.select_option" | translate }}
                </option>
                <option value="12">
                  12 {{ "inputs.month" | translate }}
                </option>
                <option value="24">
                  24 {{ "inputs.month" | translate }}
                </option>
                <option value="36">
                  36 {{ "inputs.month" | translate }}
                </option>
                <option value="48">
                  48 {{ "inputs.month" | translate }}
                </option>
                <option value="60">
                  60 {{ "inputs.month" | translate }}
                </option>
                <option value="72">
                  72 {{ "inputs.month" | translate }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div>
            <div class="mb-3">
              <label for="yearly_kms" class="form-label">{{
                "inputs.yearly_kms" | translate
                }}</label>
              <div class="input-group">
                <select id="yearly_kms" class="form-control" formControlName="yearly_kms">
                  <option value="" disabled selected>
                    {{ "inputs.select_option" | translate }}
                  </option>
                  <option value="5000">
                    5000
                  </option>
                  <option value="7500">
                    7500
                  </option>
                  <option value="10000">
                    10000
                  </option>
                  <option value="15000">
                    15000
                  </option>
                  <option value="20000">
                    20000
                  </option>
                  <option value="25000">
                    25000
                  </option>
                  <option value="30000">
                    30000
                  </option>
                  <option value="35000">
                    35000
                  </option>
                  <option value="40000">
                    40000
                  </option>
                  <option value="45000">
                    45000
                  </option>
                  <option value="50000">
                    50000
                  </option>
                  <option value="55000">
                    55000
                  </option>
                  <option value="60000">
                    60000
                  </option>
                </select>
              </div>
            </div>
          </div><!--  -->
        </div>
      </div>
    </div>


    <div class="col-12" [hidden]="customConfig">
      <div class="mb-3">
        <label for="price_matrix" class="form-label">{{
          "inputs.price_matrix" | translate
          }}</label>
        <div class="d-flex justify-content-start align-items-center" [class.table-disabled]="isDisabled"
          [attr.aria-disabled]="isDisabled">
          <table class="matriz">
            <thead>
              <tr>
                <th class="cell-no-border"></th>
                <th *ngFor="let col of columns">{{ col }} <span class="text-sm">{{ "inputs.month" | translate
                    }}</span></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of rows">
                <th>{{ row| formatNumberPipe3 }} <span class="text-sm">{{ "inputs.kilometers" | translate
                    }}</span></th>
                <td *ngFor="let col of columns">
                  <button [disabled]="isDisabled" (click)="handleClick(col, row)"
                    [ngClass]="{'selected': selectedOpt && col === colKey && row === rowKey}">
                    <span *ngIf="matrix_total[col]?.[row]"> {{ matrix_total[col]?.[row] | formatNumberPipe }}<span
                        class="text-sm">{{ matrix_total[col]?.[row] | formatNumberPipe2 }}</span></span>
                    <span *ngIf="!matrix_total[col]?.[row]"> - </span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

        </div>
        <div class=" mt-2">
          <input #ivaCheckbox class="form-check-input" type="checkbox" value="" id="iva_included"
            (change)="onCheckboxChange($event)" checked>
          <label class="form-check-label" for="iva_included">
            {{ "forms.buttons.iva_included" | translate }}
          </label>
        </div>

      </div>
    </div>
  </div>

</form>